module.exports = __webpack_public_path__ + "img/nobeoka.474f760a.jpg";